import {Injectable} from '@angular/core';
import {MedicalRecordProblemModel} from '../../api/model/medicalRecordProblem.model';
import {MedicalRecordProblemCreateUpdatePayload} from './payload/medicalRecordProblemCreateUpdate.payload';
import {EntityCollectionServiceBase} from '@ngrx/data';
import {
    MedicalRecordVisitReasonRepository
} from '../../../visit-reason/impl/service/ngrx/medicalRecordVisitReason.repository';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {MedicalProblemDataServiceAdapter} from './ngrx/medicalProblemDataService.adapter';
import {MedicalProblemRepository} from './ngrx/medicalProblem.repository';

@Injectable()
export class MedicalProblemSaveOneService
    extends AbstractSaveOneService<MedicalRecordProblemModel, MedicalRecordProblemCreateUpdatePayload>{

    constructor(public service: MedicalProblemRepository,
                public dataService: MedicalProblemDataServiceAdapter,
                public visitReasonService: MedicalRecordVisitReasonRepository) {
        super(service, dataService);
    }

    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [this.visitReasonService];
    }
}
